import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { PageContent } from "../../models/page-content.model";

export const pagesActions = createActionGroup({
    source: 'Pages',
    events: {
        'Get Terms': emptyProps,
        'Get Privacy Policy': emptyProps,
        'Get FAQ': emptyProps
    }
})

export const pagesApiActions = createActionGroup({
    source: 'Pages API',
    events: {
        'Fetch page': props<{ page: PageContent }>()
    }
})